export const resources_desktop_horizontal = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            //
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/desktop_horizontal/utility_background.png",
            "res/desktop_horizontal/frame_ui.png",
            "res/desktop_horizontal/frame_total_bet.png",

            "res/desktop_horizontal/back/background_0.jpg",
            "res/desktop_horizontal/back/background_1.jpg",
            "res/desktop_horizontal/back/background_2.jpg",
            "res/desktop_horizontal/back/background_3.jpg",
            "res/desktop_horizontal/back/background_4.jpg",
            "res/desktop_horizontal/back/background_5.jpg",

            "res/desktop_horizontal/fonts/font_gold_nums_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_white_nums_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_list_nums_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_credits_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/arial_regular_16_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/arial_regular_20_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/arial_bold_32_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/arial_regular_16_currency_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_coeff_desktop_horizontal.xml",

            "res/desktop_horizontal/utility_common.json",
            "res/desktop_horizontal/select_light.json",
            "res/desktop_horizontal/coin-0.json",
            "res/desktop_horizontal/coin-1.json",
            "res/desktop_horizontal/logo_jackpot.json",
            {name: "res/desktop_horizontal/uiscene.json", rus: true},
            {name: "res/desktop_horizontal/utility.json", rus: true},
            {name: "res/desktop_horizontal/logo-0.json", rus: true},
            {name: "res/desktop_horizontal/logo-1.json", rus: true}
        ]
};


//////////////////
// WEBPACK FOOTER
// ./res/desktop_horizontal/resources.es6
// module id = 122
// module chunks = 0